import React, { createContext, useMemo, ReactNode } from 'react';
import startTracking from '../startTracking';
import { prodUrl, devUrl } from '../constants';

const ANALYTICS_ENDPOINT = {
  production: prodUrl,
  prod: prodUrl,
  dev: devUrl,
  development: devUrl,
  test: 'https://apim.carvanatech.com/web-eventable/api/graph',
  uat: 'https://apim.cvuat.com/web-eventable/api/graph',
};

const defaultContext = {
  trackEvent: (_eventName: string, _customAttributes?: object) => {},
};

const AnalyticsContext = createContext(defaultContext);

export type ContextType = typeof defaultContext;

type OwnProps = {
  children: ReactNode;
  environment: keyof typeof ANALYTICS_ENDPOINT;
  track: string;
  projectName: string;
  correlationId?: string;
  payloadMetaAttributes?: {};
  debug?: boolean;
};

export const AnalyticsProvider = ({
  children,
  environment,
  track,
  projectName,
  correlationId = '',
  payloadMetaAttributes = {},
  debug = true,
}: OwnProps) => {
  const endpoint = ANALYTICS_ENDPOINT[environment] || ANALYTICS_ENDPOINT.dev;

  const trackData = useMemo(
    () =>
      startTracking(
        environment,
        endpoint,
        track,
        projectName,
        correlationId,
        payloadMetaAttributes,
        debug,
      ),
    [],
  );

  const trackEvent = (eventName: string, customAttributes?: object) => {
    trackData({
      eventName,
      customAttributes: customAttributes || {},
    });
  };

  const value = useMemo((): ContextType => ({ trackEvent }), [trackEvent]);

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export default AnalyticsContext;
